import { styled } from "@mui/material/styles"; // Note the import change
import { Box, Typography, Button } from "@mui/material";

export const THEME_COLOR = '#5E8E7E'; 
export const BG_COLOR = '#F4F6F8';

export const PageWrapper = styled('div')(({ theme }) => ({
  backgroundColor: BG_COLOR,
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  fontFamily: "'Roboto', sans-serif",
}));

export const FormContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#ffffff',
  padding: '20px', // Reduced from 30px
  borderRadius: '12px',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
  width: '100%',
}));

export const HeaderRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '20px', // Reduced from 30px
}));

export const SectionLabel = styled(Typography)(({ theme }) => ({
  fontWeight: '500 !important',
  color: '#333',
  marginBottom: '4px !important', // Reduced from 8px
  fontSize: '0.85rem !important', // Reduced from 0.9rem
}));

export const PrimaryButton = styled(Button)(({ theme }) => ({
  backgroundColor: `${THEME_COLOR} !important`,
  color: 'white !important',
  textTransform: 'none',
  padding: '10px 50px',
  fontWeight: '600 !important',
  borderRadius: '6px',
  width: '200px',
  
  '&:hover': {
    backgroundColor: '#4a7566 !important',
  },
}));

export const SecondaryButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#dbece6 !important',
  color: `${THEME_COLOR} !important`,
  textTransform: 'none',
  padding: '8px 20px',
  fontWeight: '600 !important',
  borderRadius: '6px',
  
  '&:hover': {
    backgroundColor: '#c9e0d8 !important',
  },
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  borderColor: '#ccc !important',
  color: '#666 !important',
  textTransform: 'none',
  padding: '10px 50px',
  fontWeight: '600 !important',
  marginRight: '15px !important',
  borderRadius: '6px',
  width: '200px',

  '&:hover': {
    backgroundColor: '#f5f5f5 !important',
    borderColor: '#bbb !important',
  },
}));